import theme, { Colors } from '@qnpm/q-theme';
const { scenes: { baseColor } } = Colors;
const { font, responsive: { scale } } = theme;
class Style {
    constructor(isScale) {
        this.getStyle = () => {
            // 容器基本样式
            const baseWrapperStyle = {
                height: scale(18, this.isScale),
                paddingHorizontal: scale(8, this.isScale),
                backgroundColor: baseColor.brand,
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'row'
            };
            const baseTextStyle = {
                fontSize: this.fontSize.fontSizeS,
                color: baseColor.white,
                fontWeight: 'normal'
            };
            const baseAngleStyle = {
                width: 0,
                height: 0,
                borderLeftWidth: 4,
                borderLeftColor: 'transparent',
                borderRightWidth: 4,
                borderRightColor: 'transparent',
                position: 'absolute'
            };
            // 气泡类样式: left
            const bubbleLeftStyle = {
                wrapperStyle: Object.assign(Object.assign({}, baseWrapperStyle), { borderTopLeftRadius: scale(9, this.isScale), borderBottomLeftRadius: scale(9, this.isScale), borderTopRightRadius: scale(9, this.isScale), borderBottomRightRadius: 2 }),
                textStyle: baseTextStyle
            };
            // 气泡类样式: right
            const bubbleRightStyle = {
                wrapperStyle: Object.assign(Object.assign({}, baseWrapperStyle), { borderTopLeftRadius: scale(9, this.isScale), borderBottomRightRadius: scale(9, this.isScale), borderTopRightRadius: scale(9, this.isScale), borderBottomLeftRadius: 2 }),
                textStyle: baseTextStyle
            };
            // 气泡类样式: topCenter
            const bubbleTopCenterStyle = {
                wrapperStyle: Object.assign(Object.assign({}, baseWrapperStyle), { paddingHorizontal: scale(18, this.isScale), borderRadius: scale(9, this.isScale), minWidth: scale(32, this.isScale) }),
                angleStyle: Object.assign(Object.assign({}, baseAngleStyle), { borderTopWidth: 4, borderTopColor: baseColor.brand, top: -1 }),
                textStyle: baseTextStyle
            };
            // 气泡类样式: topRight
            const bubbleTopRightStyle = {
                wrapperStyle: Object.assign(Object.assign({}, baseWrapperStyle), { borderRadius: 9, minWidth: scale(32, this.isScale) }),
                angleStyle: Object.assign(Object.assign({}, baseAngleStyle), { borderTopWidth: 4, borderTopColor: baseColor.brand, right: 16, top: -1 }),
                textStyle: baseTextStyle
            };
            // 气泡类样式: topLeft
            const bubbleTopLeftStyle = {
                wrapperStyle: Object.assign(Object.assign({}, baseWrapperStyle), { borderRadius: 9, minWidth: scale(32, this.isScale) }),
                angleStyle: Object.assign(Object.assign({}, baseAngleStyle), { borderTopWidth: 4, borderTopColor: baseColor.brand, left: 16, top: -1 }),
                textStyle: baseTextStyle
            };
            // 气泡类样式: BottomCenter
            const bubbleBottomCenterStyle = {
                wrapperStyle: Object.assign(Object.assign({}, baseWrapperStyle), { borderRadius: scale(9, this.isScale), minWidth: scale(32, this.isScale) }),
                angleStyle: Object.assign(Object.assign({}, baseAngleStyle), { borderBottomWidth: 4, borderBottomColor: baseColor.brand, bottom: -1 }),
                textStyle: baseTextStyle
            };
            // 气泡类样式: BottomRight
            const bubbleBottomRightStyle = {
                wrapperStyle: Object.assign(Object.assign({}, baseWrapperStyle), { borderRadius: 9, minWidth: scale(32, this.isScale) }),
                angleStyle: Object.assign(Object.assign({}, baseAngleStyle), { borderBottomWidth: 4, borderBottomColor: baseColor.brand, right: 16, bottom: -1 }),
                textStyle: baseTextStyle
            };
            // 气泡类样式: BottomLeft
            const bubbleBottomLeftStyle = {
                wrapperStyle: Object.assign(Object.assign({}, baseWrapperStyle), { borderRadius: 9, minWidth: scale(32, this.isScale) }),
                angleStyle: Object.assign(Object.assign({}, baseAngleStyle), { borderBottomWidth: 4, borderBottomColor: baseColor.brand, left: 16, bottom: -1 }),
                textStyle: baseTextStyle
            };
            // 气泡类样式: notice
            const bubbleNoticeStyle = {
                wrapperStyle: Object.assign(Object.assign({}, baseWrapperStyle), { backgroundColor: baseColor.warning, height: scale(14, this.isScale), borderRadius: scale(7, this.isScale), paddingHorizontal: scale(4, this.isScale) }),
                textStyle: Object.assign(Object.assign({}, baseTextStyle), { fontSize: this.fontSize.fontSizeXS })
            };
            // 气泡类样式: notice
            const bubbleSmallNoticeStyle = {
                wrapperStyle: Object.assign(Object.assign({}, baseWrapperStyle), { backgroundColor: baseColor.warning, height: scale(8, this.isScale), borderRadius: scale(4, this.isScale), width: scale(8, this.isScale), paddingHorizontal: 0 }),
                textStyle: Object.assign(Object.assign({}, baseTextStyle), { fontSize: this.fontSize.fontSizeXS })
            };
            return {
                bubbleLeftStyle: bubbleLeftStyle,
                bubbleRightStyle: bubbleRightStyle,
                bubbleTopCenterStyle: bubbleTopCenterStyle,
                bubbleTopRightStyle: bubbleTopRightStyle,
                bubbleTopLeftStyle: bubbleTopLeftStyle,
                bubbleNoticeStyle: bubbleNoticeStyle,
                bubbleSmallNoticeStyle: bubbleSmallNoticeStyle,
                bubbleBottomCenterStyle: bubbleBottomCenterStyle,
                bubbleBottomRightStyle: bubbleBottomRightStyle,
                bubbleBottomLeftStyle: bubbleBottomLeftStyle
            };
        };
        this.isScale = !!isScale;
        this.fontSize = isScale ? font.size.scaled : font.size.unscaled;
    }
}
export default Style;
